var map = {
	"./Bill-100.png": 2021,
	"./Bill-50.png": 2022,
	"./Cancel Subscription-100.png": 2023,
	"./Checked-Checkbox-100.png": 2024,
	"./Euro Price Tag-100.png": 2025,
	"./Euro Price Tag-50.png": 2026,
	"./Food-100.png": 2027,
	"./Food-50.png": 2028,
	"./Fork-100.png": 2029,
	"./Future-100.png": 2030,
	"./Future-50.png": 2031,
	"./Living Room-100.png": 2032,
	"./Living Room-50.png": 2033,
	"./Money Bag-100.png": 2034,
	"./Money Bag-50.png": 2035,
	"./Receipt-100.png": 2036,
	"./Receipt-50.png": 2037,
	"./Recurring Appointment-100.png": 2038,
	"./Refund-50.png": 2039,
	"./Restaurant-100.png": 2040,
	"./Restaurant-50.png": 2041,
	"./Shopping Cart Loaded-100.png": 2042,
	"./Shopping Cart Loaded-50.png": 2043,
	"./Sigma-100.png": 2044,
	"./Sigma-50.png": 2045,
	"./Starred Ticket-50.png": 2046,
	"./Table-100.png": 2047,
	"./Table-50.png": 2048,
	"./Time-100.png": 2049,
	"./Time-50.png": 2050,
	"./Trophy-100.png": 2051,
	"./Trophy-50.png": 2052,
	"./User Group-50.png": 2053,
	"./User Groups-100.png": 2054,
	"./Waiter-100.png": 2055,
	"./Waiter-50.png": 2056,
	"./Wine Glass-100.png": 2057,
	"./Wine Glass-50.png": 2058,
	"./a1/download-128.png": 2059,
	"./a1/fast_forward-128.png": 2060,
	"./a1/scan_wifi-128.png": 2061,
	"./a1/upload-128.png": 2062,
	"./a1/wifi-128.png": 2063,
	"./average-math-100.png": 2064,
	"./choose-page-96.png": 2065,
	"./pie-chart-100.png": 2066,
	"./rain-100.png": 2067,
	"./rain-50.png": 2068,
	"./rating-filled-100.png": 2069,
	"./secured-letter-100.png": 2070,
	"./temperature-100.png": 2071,
	"./temperature-50.png": 2072,
	"./weatherIcons/01d.png": 987,
	"./weatherIcons/01n.png": 988,
	"./weatherIcons/02d.png": 989,
	"./weatherIcons/02n.png": 990,
	"./weatherIcons/03d.png": 991,
	"./weatherIcons/03n.png": 992,
	"./weatherIcons/04d.png": 993,
	"./weatherIcons/04n.png": 994,
	"./weatherIcons/09d.png": 995,
	"./weatherIcons/09n.png": 996,
	"./weatherIcons/10d.png": 997,
	"./weatherIcons/10n.png": 998,
	"./weatherIcons/11d.png": 999,
	"./weatherIcons/11n.png": 1000,
	"./weatherIcons/13d.png": 1001,
	"./weatherIcons/13n.png": 1002,
	"./weatherIcons/50d.png": 1003,
	"./weatherIcons/50n.png": 1004
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 986;